import { SSTableComponent } from './shared/components/ss-table/ss.table.component';
import { SSInputComponent } from './shared/components/ss.input/ss.input.component';
// @ANGULAR COMPONENTS
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// BOOTSTRAP
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

// VIEW COMPONENTS
import { MainComponent } from './views/main/main.component';
import { DashboardView } from './views/dashboard/dashboard.view';
import { BlankView } from './views/blank/blank.view';

// SHARED COMPONENTS
import { ProductsOverviewComponent } from './shared/components/products.overview/products.overview.component';
import { MemberVersionsComponent } from './shared/components/member.versions/member.versions.component';
import { FooterComponent } from './shared/footer/footer.component';
import { NavMenuComponent } from './shared/navmenu/navmenu.component';
import { SearchResultComponent } from './shared/components/search-result/search-result.component';
import { SSLogoComponent } from './shared/ss-logo/ss-logo.component';
import { TagsComponent } from './shared/components/tags/tags.component';
import { TicketPanelComponent } from './shared/ticket.panel/ticket.panel.component';
import { TicketListComponent } from './shared/components/ticket.list/ticket.list.component';
import { TopNavBarCrumbs } from './shared/topnavcrumbs/topnavcrumbs.component';
import { TopNavBarComponent } from './shared/topnavbar/topnavbar.component';
import { RatingOverviewComponent } from './shared/components/rating.overview/rating.overview.component';
import { PaginatorModule } from './shared/components/paginator/paginator.component';

import { PipesModule } from './pipes/_pipes.module';
import { TableHeaderComponent } from './shared/components/table.header/table.header.component';

// PERFECT-SCROLL IMPORTS & CONFIG
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = { suppressScrollX: true };

// PRIMENG IMPORTS
import {
    TabViewModule,
    DropdownModule,
    OverlayPanelModule,
    CalendarModule,
    ScheduleModule,
    InputSwitchModule,
    CheckboxModule,
    DragDropModule,
    ChartModule,
    MenuModule,
    MenuItem,
    MultiSelectModule,
    ToggleButtonModule,
    SplitButtonModule,
    TooltipModule,
    SplitButton,
    TreeTableModule,
    TreeNode
} from 'primeng/primeng';

// CKEditor IMPORT
import { CKEditorModule } from 'ng2-ckeditor';

@NgModule({
    declarations: [
        // MAIN VIEW COMPONENTS
        MainComponent,

        // LAYOUT VIEW COMPONENTS
        DashboardView,
        BlankView,

        // SHARED COMPONENTS
        NavMenuComponent,
        TopNavBarComponent,
        FooterComponent,
        TopNavBarCrumbs,
        SSLogoComponent,
        TicketPanelComponent,
        TicketListComponent,
        TopNavBarComponent,
        TagsComponent,
        ProductsOverviewComponent,
        MemberVersionsComponent,
        RatingOverviewComponent,
        SearchResultComponent,
        TableHeaderComponent,
        SSInputComponent,
        SSTableComponent
    ],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,

        BsDropdownModule.forRoot(),
        OverlayPanelModule,

        // PRIMENG
        TabViewModule,
        DropdownModule,
        PaginatorModule,
        OverlayPanelModule,
        CalendarModule,
        ScheduleModule,
        InputSwitchModule,
        CheckboxModule,
        DragDropModule,
        ChartModule,
        MenuModule,
        MultiSelectModule,
        ToggleButtonModule,
        SplitButtonModule,
        TooltipModule,
        TreeTableModule,

        PipesModule,

        // BROWSER ANIMATION
        BrowserAnimationsModule,

        CKEditorModule,
        PerfectScrollbarModule
    ],
    exports: [
        // COMMON
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        // LAYOUT
        MainComponent,
        DashboardView,
        BlankView,

        // SHARED COMPONENTS
        NavMenuComponent,
        TopNavBarComponent,
        FooterComponent,
        TopNavBarCrumbs,
        SSLogoComponent,
        TicketPanelComponent,
        TicketListComponent,
        TopNavBarComponent,
        TagsComponent,
        ProductsOverviewComponent,
        MemberVersionsComponent,
        RatingOverviewComponent,
        RatingOverviewComponent,

        // PRIMENG
        TabViewModule,
        DropdownModule,
        PaginatorModule,
        OverlayPanelModule,
        CalendarModule,
        ScheduleModule,
        InputSwitchModule,
        CheckboxModule,
        DragDropModule,
        ChartModule,
        MenuModule,
        MultiSelectModule,
        ToggleButtonModule,
        SplitButtonModule,
        TooltipModule,
        TreeTableModule,

        PipesModule,

        // BROWSER ANIMATION
        BrowserAnimationsModule,

        CKEditorModule,
        SearchResultComponent,
        TableHeaderComponent,
        SSInputComponent,
        SSTableComponent
    ]

})
export class SharedAppModule { }
